var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.name
    ? _c(
        "el-button",
        {
          attrs: {
            size: _vm.size,
            type: _vm.type,
            icon: _vm.icon,
            disabled: _vm.disabled,
            circle: _vm.circle,
          },
          on: { click: _vm.click },
        },
        [_vm._v(_vm._s(_vm.name))]
      )
    : _c("el-button", {
        attrs: {
          size: _vm.size,
          type: _vm.type,
          icon: _vm.icon,
          disabled: _vm.disabled,
          circle: _vm.circle,
        },
        on: { click: _vm.click },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }